export const IHidePopUpUseCaseType = Symbol('IHidePopUpUseCase');
